import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpParams } from "@angular/common/http";
import { IMyDpOptions } from "mydatepicker";
import * as moment from "moment";
import { DemissaoFuncionariosService } from "./demissao-funcionarios.service";
import { NotificationsService } from "angular2-notifications";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "ngx-demissao",
  templateUrl: "./demissao-funcionarios.component.html",
  styleUrls: ["./demissao-funcionarios.component.scss"],
})
export class DemissaoFuncionariosComponent implements OnInit {
  public yesterday = new Date(new Date().valueOf() - 1000 * 60 * 60 * 24);

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: "dd/mm/yyyy",
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    disableUntil: { year: this.yesterday.getFullYear(), month: this.yesterday.getMonth() + 1, day: this.yesterday.getDate() },
  };

  public formDemissao: FormGroup;
  public listMotivo = null;
  public rowData = null;
  public matFunc = null;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private service: DemissaoFuncionariosService,
    private notifications: NotificationsService,
    private router: Router,
    private spinnerService: NgxSpinnerService
  ) {
    this.formDemissao = this.formBuilder.group({
      nome: [""],
      cpf: [""],
      matricula: [""],
      motivo: [""],
      dataDemissao: [null],
    });
    this.limparForm();
    this.listMotivo = [
      {
        motivo: "DEMISSAO POR JUSTA CAUSA",
        descricao: "DEMISSÃO POR JUSTA CAUSA",
      },
      {
        motivo: "DEMISSAO SEM JUSTA CAUSA",
        descricao: "DEMISSÃO SEM JUSTA CAUSA",
      },
      {
        motivo: "PEDIDO DE DEMISSAO PELO FUNCIONARIO",
        descricao: "PEDIDO DE DEMISSÃO PELO FUNCIONÁRIO",
      },
      {
        motivo: "ACORDO ENTRE AS PARTES",
        descricao: "ACORDO ENTRE AS PARTES",
      },
      {
        motivo: "DEMISSAO CONSENSUAL",
        descricao: "DEMISSÃO CONSENSUAL",
      },
    ];
  }

  limparForm() {
    this.formDemissao.reset();
  }

  limparDados() {
    this.limparForm();
    this.rowData = [];
    this.matFunc = 0;
  }

  ngOnInit() {
    let resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onDateChanged(event) {
    this.formDemissao.patchValue({dataDemissao: event})
  }

  pesquisaMatricula(data) {
    this.spinnerService.show();

    let params = new HttpParams();
    if (data.nome != null && data.nome != "") {
      params = params.append("nome", data.nome);
    }
    if (data.cpf != null && data.cpf != "") {
      params = params.append("cpf", data.cpf);
    }
    if (data.matricula != null && data.matricula != "") {
      params = params.append("matricula", data.matricula);
    }

    this.service.buscaFuncionarios(params, (response) => {
      this.matFunc = response.content.length;
      this.rowData = response.content;
      this.rowData = this.rowData.map((data) => {
        this.spinnerService.hide();
        return {
          nome: data.pessoa.nome,
          cpf: data.pessoa.cpf,
          matricula: data.funcionario.matricula,
          cargo: data.funcionario.cargo,
          status: data.funcionario.status,
        };
      });

      if (this.matFunc == 0) {
        this.spinnerService.hide();
        this.notifications.error("Funcionário não encontrado.");
      }
    }, null);
  }

  saveDemissao(data) {
    if ((!this.rowData) || (this.rowData.length === 0)) {
      this.notifications.warn("É necessário pesquisar um funcionário.");
      return;
    }

    if (!data.motivo || data.motivo === "null" || !data.dataDemissao || data.dataDemissao === "null") {
      this.notifications.warn("Preencha os campos obrigatórios.");
      return;
    }

    data.dataDemissao = this.getDateTimestamp(data.dataDemissao);
    let status = this.rowData[0].status;

    if (status !== "ATIVO") {
      if (status === "DEMITIDO") {
        this.notifications.warn(
          "Funcionário já se encontra desligado da empresa!"
        );
        return;
      }

      this.notifications.warn(
        "Não pode desligar funcionário diferente de Ativo!"
      );
      return;
    }

    this.spinnerService.show();
    data.matricula = this.rowData[0].matricula;

    let register = {
      dataDemissao: data.dataDemissao,
      matricula: data.matricula,
      motivo: data.motivo,
    };

    if (data.matricula !== null) {
      this.service.saveDismiss(
        register,
        (response) => {
          this.formatSaveDemissao(response);
        },
        null
      );
    } else {
      this.notifications.warn(
        "Não foi possível identificar a matrícula do funcionário."
      );
    }
  }

  formatSaveDemissao(ret) {
    this.spinnerService.hide();
    if (ret || ret == null) {
      this.limparDados();
      this.notifications.success("Demissão realizada com sucesso.");
    }
  }

  getDateTimestamp(data) {
    if (!data || typeof data !== "object") {
      return null; // Retorna `null` caso o dado seja inválido
    }

    let dataReturn = null;
    if ("jsdate" in data) {
      dataReturn = new Date(data.jsdate);
      dataReturn = moment(dataReturn).format("YYYY-MM-DD");
    } else if ("date" in data) {
      dataReturn = new Date(
        data.date["year"],
        data.date["month"] - 1,
        data.date["day"]
      ).getTime();
      dataReturn = moment(dataReturn).format("YYYY-MM-DD");
    }

    return dataReturn;
  }

  previousPage() {
    this.router.navigate(["/iot-dashboard"]);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
